import { useId } from 'react';
import type { IconName } from './Icon';
import { Icon } from './Icon';

type Item = {
  icon: IconName;
  top: string;
  bottom: string;
};

type Props = {
  items: readonly Item[];
};

function Seal({ item }: { item: Item }) {
  const id = useId().replace(/:/g, '');
  const topId = `seal-${id}-top`;
  const bottomId = `seal-${id}-bottom`;

  return (
    <article className="seal">
      <div className="seal__visual" aria-hidden="true">
        <svg viewBox="0 0 200 200" focusable="false">
          <defs>
            <path id={topId} d="M 100,100 m -88,0 a 88,88 0 1,1 176,0" fill="none" />
            <path id={bottomId} d="M 100,100 m -88,4 a 88,88 0 1,0 176,0" fill="none" />
          </defs>

          <circle cx="100" cy="100" r="98" className="seal__outer" />
          <circle cx="4" cy="100" r="3" className="seal__marker" />
          <circle cx="196" cy="100" r="3" className="seal__marker" />

          <text className="seal__text seal__text--top">
            <textPath href={`#${topId}`} startOffset="50%" textAnchor="middle">
              {item.top.toUpperCase()}
            </textPath>
          </text>
          <text className="seal__text seal__text--bottom">
            <textPath href={`#${bottomId}`} startOffset="50%" textAnchor="middle">
              {item.bottom.toUpperCase()}
            </textPath>
          </text>
        </svg>

        <span className="seal__center">
          <Icon name={item.icon} size={49} strokeWidth={1.6} />
        </span>
      </div>
      <h3 className="sr-only">{item.top}</h3>
      <p className="sr-only">{item.bottom}</p>
    </article>
  );
}

export function GuaranteeSeals({ items }: Props) {
  return (
    <div className="seals-grid">
      {items.map((item) => <Seal key={item.top} item={item} />)}
    </div>
  );
}
